export function formatValueForError(value: unknown, maxLength = 500): string {
  let jsonStr: string | undefined
  try {
    jsonStr = JSON.stringify(value, null, 2)
  } catch {
    // Tool inputs can be cyclic (a custom tool's raw return value or an error
    // with req/res references). Break cycles so formatting an error can never
    // throw its own JSON.stringify error.
    const ancestors: unknown[] = []
    jsonStr = JSON.stringify(value, function (this: unknown, _key, val) {
      if (ancestors.length > 0) {
        const thisPos = ancestors.indexOf(this)
        if (thisPos !== -1) {
          ancestors.splice(thisPos + 1)
        } else {
          ancestors.push(this)
        }
        if (
          typeof val === 'object' &&
          val !== null &&
          ancestors.includes(val)
        ) {
          return '[Circular]'
        }
      } else {
        ancestors.push(val)
      }
      return val
    }, 2)
  }
  const truncated = (jsonStr ?? 'undefined').length > maxLength
    ? (jsonStr ?? 'undefined').slice(0, maxLength) + '...(truncated)'
    : (jsonStr ?? 'undefined')
  if (value === null || value === undefined || typeof value !== 'object') {
    return `${truncated} (type: ${value === null ? 'null' : typeof value})`
  }
  return truncated
}
